import { LessonTaskStepKeys } from '../../main/constants/lesson-task-step-keys.ts';
import { RootState } from '../../main/store/main.store.ts';
import { LessonTaskStepKey } from '../../main/types/asset/lesson.types.ts';
import { getLessonsUtil } from '../../main/utils/asset/lessons.util.ts';
import { createMemoizedSelector } from '../../main/utils/selector/create-memoized-selector.ts';

export const selectFirstIncompleteLessonTaskStep = createMemoizedSelector(
  (state: RootState) => state.progress.lastCompletedStep,
  (lastCompletedStep): LessonTaskStepKey => {
    if (!lastCompletedStep) {
      return LessonTaskStepKeys.DEFAULT_CURRENT;
    }
    return getLessonsUtil().getNextStepKey(lastCompletedStep);
  }
);
